"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedUltraQuoteResponse = void 0;
const web3_js_1 = require("@solana/web3.js");
const superstruct_1 = require("superstruct");
const PublicKeyFromString = (0, superstruct_1.coerce)((0, superstruct_1.instance)(web3_js_1.PublicKey), (0, superstruct_1.string)(), (value) => new web3_js_1.PublicKey(value));
const AmountFromString = (0, superstruct_1.coerce)((0, superstruct_1.bigint)(), (0, superstruct_1.string)(), (value) => BigInt(value));
const NumberFromString = (0, superstruct_1.coerce)((0, superstruct_1.string)(), (0, superstruct_1.number)(), (value) => Number(value));
const SwapInfo = (0, superstruct_1.type)({
    ammKey: PublicKeyFromString,
    label: (0, superstruct_1.string)(),
    inputMint: (0, superstruct_1.string)(),
    outputMint: (0, superstruct_1.string)(),
    inAmount: AmountFromString,
    outAmount: AmountFromString,
});
const RoutePlanStep = (0, superstruct_1.type)({
    swapInfo: SwapInfo,
    percent: (0, superstruct_1.number)(),
});
const RoutePlanWithMetadata = (0, superstruct_1.array)(RoutePlanStep);
const PlatformFee = (0, superstruct_1.type)({
    feeBps: (0, superstruct_1.number)(),
});
exports.FormattedUltraQuoteResponse = (0, superstruct_1.type)({
    inputMint: PublicKeyFromString,
    inAmount: AmountFromString,
    outputMint: PublicKeyFromString,
    outAmount: AmountFromString,
    otherAmountThreshold: AmountFromString,
    priceImpactPct: NumberFromString,
    routePlan: RoutePlanWithMetadata,
    slippageBps: (0, superstruct_1.number)(),
    contextSlot: (0, superstruct_1.defaulted)((0, superstruct_1.number)(), 0),
    computedAutoSlippage: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    transaction: (0, superstruct_1.nullable)((0, superstruct_1.string)()),
    swapType: (0, superstruct_1.string)(),
    gasless: (0, superstruct_1.boolean)(),
    requestId: (0, superstruct_1.string)(),
    prioritizationFeeLamports: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    prioritizationFeePayer: (0, superstruct_1.nullable)(PublicKeyFromString),
    rentFeeLamports: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    rentFeePayer: (0, superstruct_1.nullable)(PublicKeyFromString),
    signatureFeeLamports: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    signatureFeePayer: (0, superstruct_1.nullable)(PublicKeyFromString),
    feeBps: (0, superstruct_1.number)(),
    router: (0, superstruct_1.string)(),
    errorMessage: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    platformFee: PlatformFee,
});
